// eslint-disable-next-line
export default {
    name: "Menu",
    status: {
        router: true,
        redux: true
    }
}
